import shopWifiStores from './shopWifiStores';

export default shopWifiStores;
